class TcsBuyModule extends HTMLElement {
  q(sel) {
    return this.querySelector(sel) || (this.portalRoot ? this.portalRoot.querySelector(sel) : null);
  }
  qa(sel) {
    const list = Array.from(this.querySelectorAll(sel));
    if (this.portalRoot) list.push(...this.portalRoot.querySelectorAll(sel));
    return list;
  }

  connectedCallback() {
    const matrixEl = this.q('[data-tcs-matrix]');
    const scentsEl = this.q('[data-tcs-scents]');
    const checked = this.q('input[name="tcs-size"]:checked');
    if (!matrixEl || !scentsEl || !checked) return;

    try {
      this.matrix = JSON.parse(matrixEl.textContent);
      this.scents = JSON.parse(scentsEl.textContent);
    } catch (e) {
      console.error('[tcs] kunne ikke læse prisdata', e);
      return;
    }

    this.cta = this.q('[data-tcs-cta]');
    this.stickyCta = this.q('[data-tcs-sticky-cta]');
    this.errorEl = this.q('[data-tcs-error]');
    this.samplesMin = Number(this.dataset.samplesMin) || 2;
    this.maxQty = this.qa('input[name="tcs-qty"]').length || 3;

    this.drawerEl = this.q('[data-tcs-drawer]');
    this.drawerOverlayEl = this.q('[data-tcs-drawer-overlay]');

    this.state = {
      variant: checked.value, qty: Number((this.q('input[name="tcs-qty"]:checked') || {}).value) || 1, picks: [],
      soldOut: [], notMade: [], wentUp: false, expanded: false,
      activeSlot: null,
      filter: this.dataset.defaultAudience || ''
    };

    this._onChange = (e) => {
      if (e.target.matches('[data-tcs-drawer-agree]') && e.target.checked) {
        const row = this.q('[data-tcs-drawer-terms]');
        if (row) row.removeAttribute('data-error');
        this.setTermsError('');
      }
      if (e.target.name === 'tcs-size') this.changeSize(e.target.value);
      if (e.target.name === 'tcs-qty') {
        const qty = Number(e.target.value);
        this.closeDrawer();
        this.set({
          qty: qty, picks: this.state.picks.slice(0, qty - 1),
          soldOut: [], notMade: [], expanded: false
        });
      }
      if (e.target.matches('[data-tcs-drawer-agree]')) {
        const row = this.q('[data-tcs-drawer-terms]');
        if (row) row.removeAttribute('data-error');
      }
    };

    this._onClick = (e) => {
      if (e.target.closest('[data-tcs-gift]')) return this.setQtyTo(this.samplesMin);
      if (e.target.closest('[data-tcs-expand]')) return this.set({ expanded: true });
      if (e.target.closest('[data-tcs-upsell-slot]')) {
        this.setQtyTo(3);
        return this.openDrawer(this.need - 1);
      }
      if (e.target.closest('[data-tcs-drawer-nudge-cta]')) {
        return this.applyNudge(true);
      }
      if (e.target.closest('[data-tcs-nudge-cta]')) {
        return this.applyNudge(false);
      }
      if (e.target.closest('[data-tcs-edit-picks]')) {
        const firstEmpty = this.state.picks.findIndex((p, i) => i < this.need && !p);
        return this.openDrawer(firstEmpty > -1 ? firstEmpty : 0);
      }
      const tryBtn = e.target.closest('[data-tcs-try]');
      if (tryBtn) return this.addToCart(tryBtn.dataset.tcsTry, tryBtn);

      const removeBtn = e.target.closest('[data-tcs-slot-remove]');
      if (removeBtn) return this.removePick(Number(removeBtn.dataset.tcsSlotRemove));

      const slotEl = e.target.closest('[data-tcs-slot]');
      if (slotEl) return this.openDrawer(Number(slotEl.dataset.tcsSlot));

      if (e.target.closest('[data-tcs-drawer-close]') || e.target === this.drawerOverlayEl) {
        return this.closeDrawer();
      }
      if (e.target.closest('[data-tcs-drawer-cta]')) return this.checkoutFromDrawer();

      const filterBtn = e.target.closest('[data-tcs-filter-btn]');
      if (filterBtn) return this.setFilter(filterBtn.dataset.tcsFilterBtn);

      const scent = e.target.closest('[data-tcs-scent]');
      if (scent) return this.pickScent(scent.dataset.tcsScent);
      if (e.target.closest('[data-tcs-cta]') || e.target.closest('[data-tcs-sticky-cta]')) this.addToCart();
    };

    this.addEventListener('change', this._onChange);
    this.addEventListener('click', this._onClick);

    if (this.drawerEl && this.drawerOverlayEl) {
      this.portalRoot = document.createElement('div');
      this.portalRoot.className = 'tcs-drawer-portal';
      this.portalRoot.appendChild(this.drawerOverlayEl);
      this.portalRoot.appendChild(this.drawerEl);
      document.body.appendChild(this.portalRoot);
      this.portalRoot.addEventListener('change', this._onChange);
      this.portalRoot.addEventListener('click', this._onClick);
    }

    this._onKeydown = (e) => {
      if (e.key === 'Escape' && this.state.activeSlot !== null) this.closeDrawer();
    };
    document.addEventListener('keydown', this._onKeydown);

    this.watchCta();
    this.render();
  }

  disconnectedCallback() {
    if (this.io) this.io.disconnect();
    if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown);
    if (this.portalRoot) {
      this.portalRoot.removeEventListener('change', this._onChange);
      this.portalRoot.removeEventListener('click', this._onClick);
      this.portalRoot.remove();
    }
  }

  set(patch) { Object.assign(this.state, patch); this.render(); }

  setQtyTo(n) {
    const r = this.querySelector('input[name="tcs-qty"][value="' + n + '"]');
    if (r) r.checked = true;
    this.set({
      qty: n, picks: this.state.picks.slice(0, n - 1),
      soldOut: [], notMade: [], expanded: false
    });
  }

  get row() { return this.matrix[this.state.variant] || {}; }
  get cell() { return this.row[String(this.state.qty)]; }
  get size() { return this.row.option || ''; }
  get sizeKey() { return this.row.option_key || ''; }
  get need() { return this.state.qty - 1; }
  get missing() { return Math.max(0, this.need - this.state.picks.filter(Boolean).length); }
  get complete() { return this.missing === 0; }
  get list() { return this.scents[this.sizeKey] || []; }
  get sizeAvailable() { return this.row.available !== false; }

  keyFor(variantId) {
    const r = this.matrix[String(variantId)];
    return r ? r.option_key : '';
  }

  joinNames(list) {
    if (!list.length) return '';
    if (list.length === 1) return list[0];
    return list.slice(0, -1).join(', ') + ' ' + (this.dataset.and || 'og') + ' ' + list[list.length - 1];
  }

  changeSize(variantId, keepDrawerOpen) {
    const fromMl = this.row.ml || 0;
    const toMl = (this.matrix[String(variantId)] || {}).ml || 0;
    const dest = this.scents[this.keyFor(variantId)] || [];
    const kept = [];
    const soldOut = [];
    const notMade = [];
    this.state.picks.forEach((pick) => {
      if (!pick) return;
      const match = dest.find((s) => s.pid === pick.pid);
      if (match && match.available) kept.push(match);
      else if (match) soldOut.push(pick.title);
      else notMade.push(pick.title);
    });
    if (!keepDrawerOpen) this.closeDrawer();
    this.set({
      variant: String(variantId),
      picks: kept,
      soldOut: soldOut,
      notMade: notMade,
      wentUp: toMl > fromMl
    });
  }

  nudgeCarriesAll() {
    const n = this.cell && this.cell.nudge;
    if (!n) return false;
    const dest = this.scents[n.target_key] || [];
    return this.state.picks.filter(Boolean).every((p) => dest.some((s) => s.pid === p.pid && s.available));
  }

  render() {
    const cell = this.cell;
    if (!cell) return;

    this.querySelectorAll('[data-tcs-size]').forEach((el) => {
      el.toggleAttribute('data-selected', el.dataset.tcsSize === this.state.variant);
    });

    for (const n of Object.keys(this.row).filter((k) => /^\d+$/.test(k))) {
      const c = this.row[n];
      if (!c) continue;
      this.setText('[data-tcs-row-name="' + n + '"]', c.qty_label);
      this.setText('[data-tcs-row-total="' + n + '"]', c.total_html);
      this.setText('[data-tcs-row-unit="' + n + '"]', c.metric_html);
      this.setText('[data-tcs-row-ship="' + n + '"]', c.free_ship ? '' : c.benefit_html);
      const shipBadge = this.querySelector('[data-tcs-row-freeship="' + n + '"]');
      if (shipBadge) shipBadge.hidden = !c.free_ship;
      const row = this.querySelector('[data-tcs-qty="' + n + '"]');
      if (!row) continue;
      row.toggleAttribute('data-selected', Number(n) === this.state.qty);
      row.toggleAttribute('data-better', c.better === true);
      row.toggleAttribute('data-best', c.best === true);
    }

    this.setText('[data-tcs-total]', cell.total_html);
    this.setText('[data-tcs-sticky-price]', cell.total_html);
    this.setText('[data-tcs-sticky-summary]', this.size + ' · ' + cell.qty_label);

    let summary = cell.includes_html;
    if (this.state.qty > 1 && this.complete) {
      const names = [this.dataset.thisTitle].concat(this.state.picks.map((p) => p.title));
      summary = this.joinNames(names) + ' ' + cell.includes_tail;
    }
    this.setText('[data-tcs-includes]', summary);

    this.renderRows();
    this.renderCta();
    this.renderGift(cell);
    this.renderRowGiftBadges();
    this.renderUpgrade(cell);
    this.renderReward(cell);
    this.renderWardrobe();
    this.renderDrawerFoot();
    this.syncThemePrice();
  }

  renderRows() {
    const rows = this.querySelector('[data-tcs-rows]');
    const expand = this.querySelector('[data-tcs-expand]');
    if (rows) rows.removeAttribute('data-collapsed');
    if (expand) expand.hidden = true;
  }

  renderCta() {
    const soldOut = !this.sizeAvailable;
    const missing = this.missing;
    let label;
    if (soldOut) {
      label = this.dataset.soldOutLabel || 'Udsolgt';
    } else if (missing > 0) {
      label = missing === 1
        ? this.dataset.needOne
        : String(this.dataset.needMany || '').replace('@n', String(missing));
    } else if (this.state.qty > 1) {
      label = String(this.dataset.addMany || '').replace('@n', String(this.state.qty));
    } else {
      label = this.dataset.addOne;
    }
    [this.cta, this.stickyCta].forEach((b) => {
      if (!b) return;
      b.textContent = label;
      b.toggleAttribute('data-guide', !soldOut && missing > 0);
      b.disabled = soldOut;
      b.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
    });
  }

  renderGift(cell) {
    const gifts = this.qa('[data-tcs-gift]');
    if (!gifts.length) return;
    const applies = this.row.gift === true;
    const u = cell && cell.nudge;
    const nudgeReady = !!u && this.state.qty > 1 && this.complete;
    gifts.forEach((g) => {
      const isDrawerGift = g.classList.contains('tcs-gift--drawer');
      g.hidden = !applies || (isDrawerGift && nudgeReady);
    });
    if (!applies) return;

    const missing = this.samplesMin - this.state.qty;
    const earned = missing <= 0;
    const head = earned
      ? this.dataset.giftEarned
      : String((missing === 1 ? this.dataset.giftLockedOne : this.dataset.giftLockedMany) || '').replace('@n', String(missing));
    const sub = earned ? this.dataset.giftSubEarned : this.dataset.giftSubLocked;

    gifts.forEach((g) => {
      g.style.setProperty('--tcs-gift-order', String(this.state.qty * 2));
      g.toggleAttribute('data-earned', earned);
      g.disabled = earned;
      const h = g.querySelector('[data-tcs-gift-head]');
      const s = g.querySelector('[data-tcs-gift-sub]');
      if (h) h.textContent = head || '';
      if (s) s.textContent = sub || '';
    });
  }

  renderRowGiftBadges() {
    const applies = this.row.gift === true;
    for (const n of ['1', '2', '3']) {
      const badge = this.querySelector('[data-tcs-row-gift="' + n + '"]');
      if (badge) badge.hidden = !(applies && Number(n) >= this.samplesMin);
    }
  }

  renderUpgrade(cell) {
    const box = this.querySelector('[data-tcs-nudge]');
    const drawerBox = this.q('[data-tcs-drawer-nudge]');
    if (!box && !drawerBox) return;

    const u = cell.nudge;
    const ready = !!u && this.state.qty > 1 && this.complete;
    if (box) box.hidden = !ready;
    if (drawerBox) drawerBox.hidden = !ready;
    if (!ready) return;

    const subText = this.nudgeCarriesAll() ? u.sub_same : '';

    if (box) {
      this.setText('[data-tcs-nudge-head]', u.head);
      this.setText('[data-tcs-nudge-sub]', subText);
      this.setText('[data-tcs-nudge-cta]', u.cta);
      this.setText('[data-tcs-up-now-label]', u.now_label);
      this.setText('[data-tcs-up-new-label]', u.new_label);
      this.setText('[data-tcs-up-now-kr]', u.now_total);
      this.setText('[data-tcs-up-new-kr]', u.new_total);
      const bar = this.querySelector('[data-tcs-up-bar]');
      if (bar) bar.style.width = Math.max(0, Math.min(100, Number(u.bar_now) || 0)) + '%';
    }

    if (drawerBox) {
      this.setText('[data-tcs-drawer-nudge-head]', u.head);
      this.setText('[data-tcs-drawer-nudge-sub]', subText);
      this.setText('[data-tcs-drawer-nudge-cta]', u.cta);
      this.setText('[data-tcs-drawer-up-now-label]', u.now_label);
      this.setText('[data-tcs-drawer-up-new-label]', u.new_label);
      this.setText('[data-tcs-drawer-up-now-kr]', u.now_total);
      this.setText('[data-tcs-drawer-up-new-kr]', u.new_total);
      const drawerBar = this.q('[data-tcs-drawer-up-bar]');
      if (drawerBar) drawerBar.style.width = Math.max(0, Math.min(100, Number(u.bar_now) || 0)) + '%';
    }
  }

  renderReward(cell) {
    const el = this.querySelector('[data-tcs-reward]');
    if (!el) return;
    const upgradeShown = !this.querySelector('[data-tcs-nudge]').hidden;
    const show = this.state.wentUp && this.state.qty > 1 && !!cell.reward && !upgradeShown;
    el.hidden = !show;
    if (!show) return;
    this.setText('[data-tcs-reward-head]', cell.reward.head);
    this.setText('[data-tcs-reward-sub]', cell.reward.sub);
  }

  syncThemePrice() {
    const src = this.querySelector('[data-tcs-size="' + this.state.variant + '"] .tcs-card__price');
    if (!src) return;
    document
      .querySelectorAll('.title-wrapper .product-price .current-price, .title-wrapper [data-js-product-price-original]')
      .forEach((el) => { el.textContent = src.textContent; });
  }

  setText(sel, value) {
    const el = this.q(sel);
    if (el) el.textContent = value == null ? '' : value;
  }

  qty2Upsell() {
    const cell = this.cell;
    return this.state.qty === 2 && this.complete && !!(cell && cell.third_delta_html);
  }

  buildSlotsInto(container, activeIndex) {
    if (!container) return;
    const upsell = this.qty2Upsell();
    container.style.setProperty('--tcs-slots', String(this.state.qty + (upsell ? 1 : 0)));
    container.innerHTML = '';
    container.appendChild(this.slot(this.dataset.thisTitle, this.dataset.thisInspired, this.dataset.thisImage, true));
    for (let i = 0; i < this.need; i++) {
      const pick = this.state.picks[i];
      const active = i === activeIndex;
      container.appendChild(
        pick ? this.slot(pick.title, pick.inspired, pick.image, false, i, active) : this.emptySlot(i + 2, i, active)
      );
    }
    if (upsell) container.appendChild(this.upsellSlot(this.cell.third_delta_html));
  }

  renderWardrobe() {
    const box = this.querySelector('[data-tcs-wardrobe]');
    const editBtn = this.querySelector('[data-tcs-edit-picks]');
    if (!box) return;
    box.hidden = this.state.qty < 2;
    if (editBtn) editBtn.hidden = box.hidden || !this.complete;
    if (box.hidden) {
      this.closeDrawer();
      return;
    }

    const cell = this.cell;
    const upsell = this.qty2Upsell();
    const slots = this.querySelector('[data-tcs-slots]');
    this.buildSlotsInto(slots, this.state.activeSlot);

    const note = this.querySelector('[data-tcs-third-note]');
    if (note) {
      note.hidden = !upsell;
      note.textContent = upsell ? cell.third_note_html : '';
    }

    this.renderLost();

    const chosen = this.state.picks.filter(Boolean).length;
    this.setText('[data-tcs-slot-status]', (chosen + 1) + ' af ' + this.state.qty + ' valgt');

    this.renderDrawer();
  }

  openDrawer(index) {
    this.state.activeSlot = index;
    if (this.drawerEl) this.drawerEl.setAttribute('data-open', '');
    if (this.drawerOverlayEl) this.drawerOverlayEl.setAttribute('data-open', '');
    document.documentElement.style.overflow = 'hidden';
    this.render();
  }

  closeDrawer() {
    if (this.state.activeSlot === null) return;
    this.state.activeSlot = null;
    if (this.drawerEl) this.drawerEl.removeAttribute('data-open');
    if (this.drawerOverlayEl) this.drawerOverlayEl.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
    this.render();
  }

  renderDrawer() {
    const idx = this.state.activeSlot;
    if (idx === null) return;

    const drawerSlots = this.q('[data-tcs-drawer-slots]');
    this.buildSlotsInto(drawerSlots, idx);

    const status = this.q('[data-tcs-drawer-status]');
    if (status) {
      const chosen = this.state.picks.filter(Boolean).length;
      status.textContent = (chosen + 1) + ' af ' + this.state.qty + ' valgt';
    }

    const prompt = this.q('[data-tcs-drawer-prompt]');
    if (prompt) prompt.textContent = this.state.picks[idx] ? this.dataset.swapLabel : this.dataset.pickLabel;

    const listEl = this.q('[data-tcs-drawer-scent-list]');
    if (listEl) {
      if (this._builtFor !== this.sizeKey) {
        this.buildScentList(listEl);
        this._builtFor = this.sizeKey;
      }
      this.markPicked(listEl);
    }
  }

  buildScentList(listEl) {
    listEl.textContent = '';
    this._pickedEls = [];
    const frag = document.createDocumentFragment();
    const tal = { '': 0, women: 0, men: 0, unisex: 0 };

    this.list.forEach((s) => {
      if (!s.available) return;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'tcs-scent';
      b.dataset.tcsScent = String(s.pid);
      b.dataset.audience = s.audience || '';
      b.innerHTML =
        '<span class="tcs-scent__img"></span>' +
        '<span class="tcs-scent__body"><span class="tcs-scent__top"><span class="tcs-scent__name"></span></span><span class="tcs-scent__insp"></span></span>' +
        '<span class="tcs-scent__mark" aria-hidden="true">✓</span>';
      if (s.image) b.querySelector('.tcs-scent__img').style.backgroundImage = 'url(' + s.image + ')';
      b.querySelector('.tcs-scent__name').textContent = s.title;
      b.querySelector('.tcs-scent__insp').textContent = s.inspired || '';
      const top = b.querySelector('.tcs-scent__top');
      if (s.badge_audience) {
        const bAud = document.createElement('span');
        bAud.className = 'tcs-scent__badge tcs-scent__badge--audience';
        bAud.textContent = s.badge_audience;
        top.appendChild(bAud);
      }
      if (s.badge_popular) {
        const bPop = document.createElement('span');
        bPop.className = 'tcs-scent__badge tcs-scent__badge--popular';
        bPop.textContent = this.dataset.bestsellerLabel || 'Bestseller';
        top.appendChild(bPop);
      }

      tal[''] += 1;
      (s.audience || '').split(' ').forEach((k) => { if (k in tal) tal[k] += 1; });
      frag.appendChild(b);
    });
    listEl.appendChild(frag);

    this.qa('[data-tcs-filter-btn]').forEach((btn) => {
      const key = btn.dataset.tcsFilterBtn;
      const n = tal[key] || 0;
      btn.hidden = key !== '' && n === 0;
      const c = btn.querySelector('[data-tcs-filter-count]');
      if (c) c.textContent = n ? String(n) : '';
    });
    if (this.state.filter && !tal[this.state.filter]) this.state.filter = '';
    this.setFilter(this.state.filter, true);
  }

  markPicked(listEl) {
    const pids = new Set(this.state.picks.filter(Boolean).map((p) => String(p.pid)));
    (this._pickedEls || []).forEach((el) => {
      if (!pids.has(el.dataset.tcsScent)) el.removeAttribute('data-selected');
    });
    this._pickedEls = [];
    pids.forEach((pid) => {
      const el = listEl.querySelector('[data-tcs-scent="' + pid + '"]');
      if (el) {
        el.setAttribute('data-selected', '');
        this._pickedEls.push(el);
      }
    });
  }

  setFilter(key, stille) {
    this.state.filter = key;
    const listEl = this.q('[data-tcs-drawer-scent-list]');
    if (listEl) listEl.dataset.filter = key;
    this.qa('[data-tcs-filter-btn]').forEach((btn) => {
      btn.setAttribute('aria-pressed', btn.dataset.tcsFilterBtn === key ? 'true' : 'false');
    });
    if (stille) return;
    const body = this.q('.tcs-drawer__body');
    if (body && listEl) body.scrollTop = Math.max(0, listEl.offsetTop - body.offsetTop - 8);
  }

  renderDrawerFoot() {
    const cell = this.cell;
    if (!cell) return;
    const missing = this.missing;

    this.setText('[data-tcs-drawer-subtotal]', cell.total_html);

    const wasEl = this.q('[data-tcs-drawer-was]');
    if (wasEl) {
      wasEl.hidden = !cell.was_html;
      wasEl.textContent = cell.was_html || '';
    }

    const savingsEl = this.q('[data-tcs-drawer-savings]');
    if (savingsEl) {
      savingsEl.hidden = !cell.savings_html;
      savingsEl.textContent = cell.savings_html || '';
    }

    const instEl = this.q('[data-tcs-drawer-installment]');
    if (instEl) {
      instEl.hidden = !cell.installment_html;
      instEl.textContent = cell.installment_html || '';
    }

    const label = this.q('[data-tcs-drawer-cta-label]');
    const btn = this.q('[data-tcs-drawer-cta]');
    if (label) {
      label.textContent = missing > 0
        ? (missing === 1 ? this.dataset.needOne : String(this.dataset.needMany || '').replace('@n', String(missing)))
        : this.dataset.checkoutLabel + ' - ' + cell.total_html;
    }
    if (btn) btn.toggleAttribute('data-guide', missing > 0);
  }

  setTermsError(msg) {
    const el = this.q('[data-tcs-drawer-terms-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  showDrawerError(msg) {
    const el = this.q('[data-tcs-drawer-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  renderLost() {
    const el = this.querySelector('[data-tcs-lost]');
    if (!el) return;
    const lost = this.state.soldOut.concat(this.state.notMade);
    if (!lost.length) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    const template = this.state.notMade.length ? this.dataset.lostMissing : this.dataset.lostSold;
    const other = lost.length > 1 ? this.dataset.otherMany : this.dataset.otherOne;
    const parts = String(template || '').replace('@size', this.size).replace('@other', other).split('@names');
    el.textContent = '';
    el.append(parts[0] || '');
    const strong = document.createElement('b');
    strong.textContent = this.joinNames(lost);
    el.append(strong);
    el.append(parts[1] || '');
    el.hidden = false;
  }

  slot(title, inspired, image, locked, index, active) {
    const el = document.createElement('div');
    el.className = 'tcs-slot' + (locked ? ' tcs-slot--locked' : '');
    if (!locked && index !== undefined && index !== null) {
      el.dataset.tcsSlot = String(index);
      if (active) el.setAttribute('data-active', '');
    }
    el.innerHTML = '<span class="tcs-slot__img"></span><span class="tcs-slot__name"></span><span class="tcs-slot__insp"></span>';
    if (image) el.querySelector('.tcs-slot__img').style.backgroundImage = 'url(' + image + ')';
    el.querySelector('.tcs-slot__name').textContent = title || '';
    el.querySelector('.tcs-slot__insp').textContent = inspired || '';
    if (!locked && index !== undefined && index !== null) {
      const rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'tcs-slot__remove';
      rm.dataset.tcsSlotRemove = String(index);
      rm.setAttribute('aria-label', this.dataset.removeLabel || 'Fjern');
      rm.innerHTML = '<svg width="9" height="9" viewBox="0 0 9 9" fill="none" aria-hidden="true"><path d="M1 1l7 7M8 1l-7 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
      el.appendChild(rm);
    }
    return el;
  }

  upsellSlot(deltaHtml) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'tcs-slot tcs-slot--upsell';
    b.dataset.tcsUpsellSlot = '';
    b.innerHTML = '<span class="tcs-slot__delta"></span><span class="tcs-slot__deltaLabel"></span>';
    b.querySelector('.tcs-slot__delta').textContent = deltaHtml;
    b.querySelector('.tcs-slot__deltaLabel').textContent = this.dataset.upsellLabel || '';
    return b;
  }

  emptySlot(n, index, active) {
    const el = document.createElement('div');
    el.className = 'tcs-slot tcs-slot--empty';
    if (index !== undefined && index !== null) {
      el.dataset.tcsSlot = String(index);
      if (active) el.setAttribute('data-active', '');
    }
    el.innerHTML =
      '<svg class="tcs-slot__plus" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="8.25" stroke="currentColor" stroke-width="1.3"/><path d="M9 5.5v7M5.5 9h7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>' +
      '<span class="tcs-slot__pick"></span>' +
      '<span class="tcs-slot__num"></span>';
    el.querySelector('.tcs-slot__pick').textContent = this.dataset.slotPickLabel || 'Vælg duft';
    el.querySelector('.tcs-slot__num').textContent = (this.dataset.slotLabel || 'Plads') + ' ' + n;
    return el;
  }

  pickScent(pid) {
    const idx = this.state.activeSlot;
    if (idx === null) return;
    const s = this.list.find((x) => String(x.pid) === String(pid));
    if (!s || !s.available) return;
    const picks = this.state.picks.slice();
    picks[idx] = s;
    let nextIdx = idx;
    for (let i = idx + 1; i < this.need; i++) {
      if (!picks[i]) { nextIdx = i; break; }
    }
    this.state.activeSlot = nextIdx;
    this.set({ picks: picks, soldOut: [], notMade: [] });
  }

  removePick(index) {
    if (index === null || index === undefined || index < 0 || index >= this.state.picks.length) return;
    const picks = this.state.picks.slice();
    picks[index] = undefined;
    this.state.activeSlot = index;
    this.set({ picks: picks });
  }

  applyNudge(keepDrawerOpen) {
    const n = this.cell && this.cell.nudge;
    if (!n) return;
    const r = this.querySelector('input[name="tcs-size"][value="' + n.target + '"]');
    if (r) r.checked = true;
    this.changeSize(n.target, keepDrawerOpen);
    if (window.dataLayer) window.dataLayer.push({ event: 'tcs_upgrade', tcs_type: 'size', tcs_to: this.size });
  }

  showError(msg) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg;
    this.errorEl.hidden = !msg;
  }

  addToCart(singleId, btn) {
    this.showError('');
    if (!singleId && !this.sizeAvailable) return;
    if (!singleId && !this.complete) {
      const prompt = this.q('[data-tcs-drawer-prompt]');
      if (prompt) prompt.setAttribute('data-error', '');
      const firstEmpty = this.state.picks.findIndex((p, i) => i < this.need && !p);
      return this.openDrawer(firstEmpty > -1 ? firstEmpty : 0);
    }

    const items = singleId
      ? [{ id: Number(singleId), quantity: 1 }]
      : [{ id: Number(this.state.variant), quantity: 1 }].concat(
          this.state.picks.map((p) => ({ id: Number(p.id), quantity: 1 }))
        );
    const body = JSON.stringify({ items: items });
    const headers = { 'Content-Type': 'application/json' };

    const busy = btn || this.cta;
    busy.setAttribute('aria-busy', 'true');
    const done = () => busy.removeAttribute('aria-busy');

    if (typeof window.handleAddToCart === 'function') {
      window.handleAddToCart(body, items.length, headers, done);
      return;
    }

    fetch('/cart/add.js', { method: 'POST', headers: headers, body: body })
      .then((r) => r.json())
      .then((data) => {
        if (data.status) {
          this.showError(data.description || data.message || this.dataset.cartErrorLabel || '');
          return;
        }
        window.location.href = '/cart';
      })
      .catch(() => this.showError(this.dataset.cartErrorLabel || ''))
      .finally(done);
  }

  checkoutFromDrawer() {
    if (!this.complete) return;
    if (!this.sizeAvailable) return;

    const termsRow = this.q('[data-tcs-drawer-terms]');
    const agree = this.q('[data-tcs-drawer-agree]');
    if (termsRow && agree && !agree.checked) {
      termsRow.setAttribute('data-error', '');
      this.setTermsError(this.dataset.termsRequired || '');
      termsRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (typeof agree.focus === 'function') agree.focus({ preventScroll: true });
      return;
    }

    this.showDrawerError('');
    const items = [{ id: Number(this.state.variant), quantity: 1 }].concat(
      this.state.picks.map((p) => ({ id: Number(p.id), quantity: 1 }))
    );
    const body = JSON.stringify({ items: items });

    const btn = this.q('[data-tcs-drawer-cta]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    const done = () => { if (btn) btn.removeAttribute('aria-busy'); };

    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then((r) => r.json())
      .then((data) => {
        if (data.status) {
          this.showDrawerError(data.description || data.message || this.dataset.cartErrorLabel || '');
          done();
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(() => {
        this.showDrawerError(this.dataset.cartErrorLabel || '');
        done();
      });
  }

  watchCta() {
    if (!this.cta || !('IntersectionObserver' in window)) return;
    const bar = this.querySelector('[data-tcs-sticky]');
    if (!bar) return;
    this.io = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting;
        bar.toggleAttribute('data-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      },
      { threshold: 0 }
    );
    this.io.observe(this.cta);
  }
}

if (!customElements.get('tcs-buy-module')) customElements.define('tcs-buy-module', TcsBuyModule);
